import React, { useState, useCallback, useRef } from "react";
import MyLink from "../../hoc/Link/Link";
import ProjectTemp from "./ProjectTemp/ProjectTemp";
import { projects } from "../../../assets/text/ProjectText";
import { Element } from "react-scroll";
import classes from "./Project.module.css";
const Project = () => {
  const [currentVisibleItem, setCurrentVisibleItem] = useState([]);
  const [current, setCurrent] = useState(null);

  const handleVisibilityChange = useCallback((item) => {
    setCurrent(item);
    setCurrentVisibleItem((prevState) => {
      const newSet = new Set([...prevState, item]);
      return Array.from(newSet);
    });
  }, []);

  const names = currentVisibleItem.map((Mname) => {
    return (
      <li key={Mname} className={Mname === current ? classes.Current : null}>
        <MyLink noactive={true} to={Mname}>
          {" "}
          {Mname}{" "}
        </MyLink>
      </li>
    );
  });

  const projectsList = projects.map((project, index) => {
    return (
      <ProjectTemp
        key={project.name}
        name={project.name}
        image={project.image}
        link={project.link}
        id={project.id}
        description={project.description}
        techStacks={project.techStacks}
        index={index}
        current={currentVisibleItem}
        onVisible={handleVisibilityChange}
      />
    );
  });

  return (
    <Element name="Projects">
      <div className={classes.ProjectsContainer}>
        <div className={classes.ProjectHeading}>
          <h1>My Projects</h1>
          <p>Proven Skills</p>
          <ul>{names}</ul>
        </div>
        <div className={classes.ProjectsDiv}>{projectsList}</div>
      </div>
    </Element>
  );
};

export default Project;
